import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadQuestions } from "../lib/api";
import type { Theme } from "../lib/types";

export default function ThemesPage() {
  const [themes, setThemes] = useState<Theme[]>([]);

  useEffect(() => {
    void loadQuestions().then((d) => setThemes(d.themes));
  }, []);

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-semibold">Themes</h1>
      <p className="text-ink/80 max-w-prose">
        Each theme groups ten questions. Click a theme to see its questions and vote.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {themes.map((t) => (
          <Link
            key={t.id}
            to={`/themes/${t.slug}`}
            className="card hover:border-cedar transition no-underline"
          >
            <div className="flex items-baseline justify-between">
              <span className="text-xs uppercase tracking-wider text-muted">
                Theme {t.id}
              </span>
              <span className="text-xs text-muted">
                Q{t.questionRange[0]}–Q{t.questionRange[1]}
              </span>
            </div>
            <h3 className="mt-1 font-medium text-ink">{t.title}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
}
